import React, { useEffect } from "react";
import { Button, Modal } from 'react-bootstrap';
import WithRoutify from "../../hoc/WithRoutify";
import {stripHtmlTags } from "../../utils/commonUtils";
import { Link } from "react-router-dom";
import Icons from "../../components/UI/Icons";
import { use } from "react";
import NotificationTemplateService from "../../services/NotificationTemplateService";

const NotificationMessageModal = (props) => {
  const { addFormHandler,Loader, data } = props;
  const [message, setMessage] = React.useState('');
  useEffect(() => {
    console.log('data',data);
    if(data.notification_type==='email'){
    fetchMessage();
    }else{
      setMessage(data.body);
    }
  }, [data]);
  const fetchMessage = async() => {
    try{
        Loader(true)    
        const payload={
            ...data
        };
        const response = await NotificationTemplateService.gettemplate(null,data);
        console.log('response message',response);   
        if(response){
            setMessage(response.body);
        }
        Loader(false) 
    }catch(error){
      console.error('Error fetching message:', error);
    }
  }
  return (
    <>
      <Modal
        show={true}
        onHide={addFormHandler}
        dialogClassName="hResponsive"
        size="lg"
        contentClassName="h-100"
        backdrop="static"
        keyboard={false}
      >
        <div className="sh_modalBox">
          <Modal.Header closeButton>
            <Modal.Title style={{ margin: '0 auto' }}>
              <h6 className="text-lg mb-0 font-weight-bold">Message</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {message ? (
              <>
                {/* <div className="sh_logoIcon">
                  <div className="sidebar-brand-icon">
                    <Link to="/">
                      <Icons type={`Logo`} />
                    </Link>

                  </div>
                </div> */}
                <div className="row" >
                  <div className="col-12" style={{ overflowWrap: "break-word" }}>
                     <div dangerouslySetInnerHTML={{ __html: message }} />
                  </div>
                </div>
              </>
            ) : (
              <p>No Message Found</p>
            )}
            {/* {message ? (
              <p>{message}</p>
            ) : (
              <p>No Message Found</p>
            )} */}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button
              variant="primary"
              onClick={() => addFormHandler()}
            >
              Close
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default WithRoutify(NotificationMessageModal);
